import React from "react";

const StadoPayrollInfo = () => {
  return (
    <>
      <style>{`
        /* SECTION BACKGROUND */
        .info-section{
          padding:90px 8%;
          background:linear-gradient(180deg,#fff,#fff3f7);
          text-align:center;
        }

        .info-section span.sub{
          display:block;
          color:#666;
          margin-bottom:60px;
        }

        /* GRID */
        .info-grid{
          display:grid;
          grid-template-columns:1fr 1fr;
          gap:40px;
          max-width:1200px;
          margin:auto;
        }

        /* CARD */
        .info-card{
          background:white;
          border-radius:26px;
          padding:45px 35px;
          box-shadow:0 20px 55px rgba(255,80,130,.16);
          transition:.35s ease;
          position:relative;
          overflow:hidden;
        }

        /* HOVER */
        .info-card:hover{
          transform:translateY(-12px) scale(1.02);
          box-shadow:0 35px 80px rgba(255,80,130,.35);
        }

        /* ICON */
        .icon{
          width:85px;
          height:85px;
          border-radius:50%;
          background:linear-gradient(135deg,#ff3b69,#ff914d);
          display:flex;
          align-items:center;
          justify-content:center;
          margin:auto;
          margin-bottom:25px;
          box-shadow:0 0 25px rgba(255,90,140,.6);
          transition:.4s;
        }
        .info-card:hover .icon{
          transform:scale(1.1) rotate(5deg);
          box-shadow:0 0 45px rgba(255,90,140,.8);
        }

        /* SVG ICON */
        .icon svg{
          width:42px;
          fill:white;
        }

        /* TEXT */
        .info-card h3{
          font-size:24px;
          font-weight:700;
          color:#111;
        }

        .info-card p{
          color:#555;
          font-size:15px;
          margin-top:10px;
          line-height:1.6;
        }
        .section-title{
          font-size:35px;
          font-weight:700;
          color:black;
        }
        .highlight-pink {
          background: linear-gradient(90deg, #ff3b69, #ff914d);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
      }

        /* LIST */
        .info-card ul{
          list-style:none;
          margin-top:15px;
          text-align:left;
          padding-left:0;
        }
        .info-card ul li{
          padding:6px 0;
          color:#555;
          font-size:14px;
        }
        .info-card ul li::before{
          content:"✓";
          color:#ff3b69;
          font-weight:bold;
          margin-right:6px;
        }

        /* MOBILE */
        @media(max-width:900px){
          .info-grid{
            grid-template-columns:1fr;
          }
        }

        @media(max-width:768px){
          .info-section{
            padding:60px 6%;
          }

          .info-section h2{
            font-size:32px;
          }

          .info-section span.sub{
            font-size:14px;
            margin-bottom:40px;
          }

          .info-card{
            padding:30px 22px;
          }

          .icon{
            width:65px;
            height:65px;
            margin-bottom:18px;
          }

          .icon svg{
            width:32px;
          }

          .info-card h3{
            font-size:20px;
          }

          .info-card p,
          .info-card ul li{
            font-size:14px;
          }
        }

        @media(max-width:480px){
          .info-section h2{
            font-size:26px;
          }

          .info-section span.sub{
            font-size:13px;
          }

          .info-card{
            border-radius:18px;
          }

          .info-card ul{
            text-align:left;
          }
        }
      `}</style>

      <section className="info-section " id="about">
        <h2 className="section-title">
          ABOUT <span className="highlight-pink">STADO PAYROLL</span>
        </h2>
        <span className="sub">
          Smart payroll & workforce automation for high-growth businesses.
        </span>

        <div className="info-grid">
          {/* CARD 1 */}
          <div className="info-card">
            <div className="icon">
              <svg viewBox="0 0 24 24">
                <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2V19c0-3.2-6.4-4.6-9.6-4.6z"/>
              </svg>
            </div>
            <h3>What is Stado Payroll?</h3>
            <p>
              Stado Payroll is an all-in-one HRMS solution built for growing organizations.
              It replaces spreadsheets and registers with a cloud-based automated system.
              Manage office teams, track field staff via GPS, and ensure 100% payroll accuracy.
            </p>
          </div>

          {/* CARD 2 */}
          <div className="info-card">
            <div className="icon">
              <svg viewBox="0 0 24 24">
                <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1 16h-2v-2h2v2zm0-4h-2V6h2v8z"/>
              </svg>
            </div>
            <h3>Who is it for?</h3>
            <ul>
              <li><b>Corporate Offices</b> — Leave & shift automation.</li>
              <li><b>Field Teams</b> — Live GPS route tracking.</li>
              <li><b>Retail & Logistics</b> — Multi-shift & reports.</li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default StadoPayrollInfo;
